// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__hVphi","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3kTAI"};